import AES from '@ali/aes-tracker';
import { isInWindmillByMY } from '../utils/util';

function limit(data) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  if (typeof data !== 'string') return;

  if (data.length > limit) {
    data = data.substr(0, limit - 3) + '...';
  }

  return data;
}

var RESP_LIMIT_IN_WEB = 10000;
var RESP_LIMIT_IN_MINIAPP = 1000;
var REQUEST_BODY_LIMIT_IN_WEB = 10000;
var REQUEST_BODY_LIMIT_IN_MINIAPP = 2000;

function sendLog(e) {
  var url = e.url,
      success = e.success,
      msg = e.msg,
      status = e.status,
      code = e.code,
      duration = e.duration,
      traceId = e.traceId,
      params = e.params,
      body = e.body,
      response = e.response,
      headers = e.headers,
      rtype = e.rtype,
      method = e.method;

  var _ref = AES.getConfig('plugin_api') || {},
      ignoreList = _ref.ignoreList,
      sendResponseOnSuccess = _ref.sendResponseOnSuccess;

  if (ignoreList) {
    if (ignoreList.some(function (rule) {
      if (typeof rule === 'string') {
        return rule === url;
      } else if (typeof rule === 'function') {
        try {
          return rule(url, e);
        } catch (ex) {}
      } else if (rule instanceof RegExp) {
        return rule.test(url);
      }
    })) {
      return;
    }
  }

  var isInMiniApp = isInWindmillByMY();
  AES.log('api', {
    url: url,
    method: typeof method === 'string' ? method.toUpperCase() : undefined,
    // 统一为大写
    success: success,
    msg: msg,
    // msg
    status: status,
    code: code,
    // code
    duration: duration,
    trace_id: traceId,
    params: params,
    // params,
    body: limit(body, isInMiniApp ? REQUEST_BODY_LIMIT_IN_MINIAPP : REQUEST_BODY_LIMIT_IN_WEB),
    // request body
    response: !success || sendResponseOnSuccess ? limit(response, isInMiniApp ? RESP_LIMIT_IN_MINIAPP : RESP_LIMIT_IN_WEB) : undefined,
    // response,
    headers: headers,
    // headers,
    rtype: rtype
  });
}

export default sendLog;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/libs/sendLog.js
// module id = null
// module chunks = 